<h2>Dashboard!</h2><br>
<p>It's a bit empty right now!</p>

<mat-card>
    <mat-card-header>
        <mat-card-title>Test Graph</mat-card-title>
        <mat-card-subtitle>Just a test</mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
        <canvas [chartjs]="testChart"></canvas>
    </mat-card-content>
</mat-card>